var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4762 15.2578C28.2887 15.2578 28.1247 15.1875 27.9841 15.0469L15.5387 2.53125C15.3981 2.39062 15.2106 2.29688 14.9997 2.29688C14.8122 2.29688 14.6247 2.36719 14.4606 2.53125L2.01531 15C1.87468 15.1406 1.71062 15.2109 1.52312 15.2109C1.33562 15.2109 1.17156 15.1406 1.05437 15.0234C0.913746 14.9062 0.843433 14.7656 0.843433 14.5781C0.819996 14.3672 0.913746 14.1562 1.05437 14.0156L13.4294 1.54688C13.8512 1.125 14.3903 0.890625 14.9762 0.890625C15.5622 0.890625 16.1012 1.125 16.5231 1.54688L28.9684 14.0625C29.1091 14.2031 29.1794 14.3906 29.1794 14.6016C29.1794 14.8125 29.0622 15 28.9216 15.1172C28.7809 15.2109 28.6169 15.2578 28.4762 15.2578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6797 29.25V28.2656H17.6953V26.4844C17.6953 24.9844 16.4766 23.7891 15 23.7891C13.5 23.7891 12.3047 25.0078 12.3047 26.4844V28.2656H11.3203V29.25H5.76563C4.57031 29.25 3.60938 28.2891 3.60938 27.0937V14.9297C3.60938 14.5312 3.91406 14.2266 4.3125 14.2266C4.71094 14.2266 5.01562 14.5312 5.01562 14.9297V27.0937C5.01562 27.5156 5.34375 27.8438 5.76563 27.8438H10.8984V26.5078C10.8984 24.2344 12.75 22.4062 15 22.4062C17.25 22.4062 19.1016 24.2578 19.1016 26.5078V27.8438H24.2344C24.6562 27.8438 24.9844 27.5156 24.9844 27.0937V14.9297C24.9844 14.5312 25.2891 14.2266 25.6875 14.2266C26.0859 14.2266 26.3906 14.5312 26.3906 14.9297V27.0937C26.3906 28.2891 25.4297 29.25 24.2344 29.25H18.6797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6953 29.25V27.8438H19.1016V29.25H17.6953ZM10.8984 29.25V27.8438H12.3047V29.25H10.8984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_1131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalData);
export default __webpack_public_path__ + "static/media/PersonalData.89a00d471fa17c0eea25dede7ee3f9d4.svg";
export { ForwardRef as ReactComponent };